import React, { useState } from 'react';
import {
  Outlet,
  NavLink as RouterLink,
  useLocation
} from 'react-router-dom';
import {
  makeStyles,
  Fab,
  Tooltip
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import NavBar from './NavBar';
import TopBar from './TopBar';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#F3F3F3',
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
    fontFamily: 'Roboto'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 103,
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    },
    fontFamily: 'Roboto'
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    fontFamily: 'Roboto'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto',
    fontFamily: 'Roboto',
  },
  add: {
    position: 'fixed',
    bottom: '40px',
    right: '40px',
    width: '70px',
    height: '70px',
  },
  icone: {
    fontSize: '70px',
    color: '#ffffff'
  }
}));

const DashboardLayout = () => {
  const classes = useStyles();
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  const location = useLocation();
  console.log(location.pathname);

  const LinkBehavior = React.forwardRef((props, ref) => (
    <RouterLink ref={ref} to="/app/acervos/novo" exact {...props} />
  ));

  return (
    <div className={classes.root}>
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <NavBar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>
            <Outlet />
            {!String(location.pathname).includes('/app/acervos/') && (
              <Tooltip title="Adicionar item do acervo">
                <Fab
                  color="secondary"
                  className={classes.add}
                  component={LinkBehavior}
                >
                  <AddIcon className={classes.icone} />
                </Fab>
              </Tooltip>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
